import React, { useMemo, useState } from 'react';
import { Screen } from '../types';
import arunachalLogo from '../../../assets/Arunachal-Pradesh.png';
import { QRCodeSVG } from 'qrcode.react';

const HomeScreen = ({ navigateTo }) => {
  const [showInvite, setShowInvite] = useState(false);
  const [copied, setCopied] = useState(false);

  const inviteUrl = useMemo(() => {
    const inviter = encodeURIComponent('Tashi Tsering');
    const inviterId = encodeURIComponent('INV-1024');
    const refId = encodeURIComponent('AR-ILP-2024-9876');
    const invitee = encodeURIComponent('Tourist');
    const ts = encodeURIComponent(String(Date.now()));
    return `https://stoicstudios.in/ilp-referal/`;
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // ignore for demo
    }
  };

  const handleWhatsAppShare = async () => {
    const text = `You’re invited to apply for Arunachal ILP.\n\nOpen: ${inviteUrl}`;
    try {
      // Prefer native share on mobile if available
      if (navigator.share) {
        await navigator.share({ title: 'Arunachal ILP Invite', text, url: inviteUrl });
        return;
      }
    } catch (e) {
      // fall back to WA link
    }

    const waUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="ilp-home">
      {/* Header */}
      <div className="ilp-home-header">
        <div className="ilp-home-header-left">
          <img src={arunachalLogo} alt="Arunachal Pradesh" className="ilp-home-seal" />
          <div className="ilp-home-title">
            <h2>Arunachal ILP</h2>
            <p>Govt. of Arunachal Pradesh</p>
          </div>
        </div>
        <div className="ilp-home-header-right">
          <button className="ilp-icon-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <span className="ilp-notification-dot"></span>
          </button>
        </div>
      </div>

      <div className="ilp-home-content">
        {/* Hero Section */}
        <div className="ilp-home-hero">
          <h1>Discover the<br/><span>Land of Dawn-Lit Mountains</span></h1>
          <div className="ilp-home-carousel">
            <div className="ilp-carousel-card">
              <img src="https://picsum.photos/seed/tawang/600/400" alt="Tawang" crossOrigin="anonymous" />
              <div className="ilp-carousel-overlay">
                <span className="ilp-carousel-tag blue">Tawang</span>
                <h3>Spiritual serenity amidst clouds</h3>
              </div>
            </div>
            <div className="ilp-carousel-card">
              <img src="https://picsum.photos/seed/ziro/600/400" alt="Ziro" crossOrigin="anonymous" />
              <div className="ilp-carousel-overlay">
                <span className="ilp-carousel-tag green">Ziro Valley</span>
                <h3>Musical hills & green meadows</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Apply Card */}
        <div className="ilp-apply-card">
          <div className="ilp-apply-card-header">
            <div className="ilp-apply-card-text">
              <h3>Apply for ILP</h3>
              <p>Get your entry permit instantly for travel. Valid for tourists.</p>
            </div>
            <div className="ilp-apply-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
          </div>
          <button className="ilp-primary-btn" onClick={() => navigateTo(Screen.Consent)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            <span>Start Application</span>
          </button>
        </div>

        {/* Quick Actions */}
        <div className="ilp-quick-actions">
          <button className="ilp-action-card" onClick={() => navigateTo(Screen.MyPermits)}>
            <div className="ilp-action-icon green">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
            </div>
            <div className="ilp-action-text">
              <h4>My Permits</h4>
              <p>View active & past</p>
            </div>
          </button>
          <button className="ilp-action-card" onClick={() => navigateTo(Screen.Map)}>
            <div className="ilp-action-icon orange">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7l5-2.5 5.553 2.776a1 1 0 01.447.894v10.764a1 1 0 01-1.447.894L15 17l-6 3z" />
              </svg>
            </div>
            <div className="ilp-action-text">
              <h4>Entry & Exit</h4>
              <p>Checkpoints Map</p>
            </div>
          </button>
        </div>

        {/* Invite Tourist */}
        <div className="ilp-invite-card">
          <div className="ilp-invite-card-header">
            <div className="ilp-invite-card-text">
              <h3>Invite a Tourist</h3>
              <p>Share an invite link with your friends and family to visit Arunachal Pradesh.</p>
            </div>
            <div className="ilp-invite-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                <circle cx="8.5" cy="7" r="4" />
                <path d="M20 8v6m3-3h-6" />
              </svg>
            </div>
          </div>
          <button className="ilp-primary-btn" onClick={() => setShowInvite(true)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 12v-2a4 4 0 014-4h8a4 4 0 014 4v2" />
              <path d="M12 12v9" />
              <path d="M8 17l4 4 4-4" />
            </svg>
            <span>Generate Invite</span>
          </button>
        </div>

        {/* Advisory */}
        <div className="ilp-advisory">
          <div className="ilp-advisory-header">
            <h3>Travel Advisories</h3>
            <button>View All</button>
          </div>
          <div className="ilp-advisory-card">
            <div className="ilp-advisory-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ilp-advisory-content">
              <h4>Road Maintenance</h4>
              <p>The road to Bomdila is undergoing maintenance. Please expect minor delays during daytime.</p>
              <span className="ilp-advisory-time">Updated 2h ago</span>
            </div>
          </div>
        </div>

        <div className="ilp-home-footer">
          <p>Government of Arunachal Pradesh<br/>Digital Services © 2024</p>
        </div>
      </div>

      {/* Bottom Nav */}
      <div className="ilp-bottom-nav">
        <button className="ilp-nav-item active">
          <svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
          </svg>
          <span>Home</span>
        </button>
        <button className="ilp-nav-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
          </svg>
          <span>Status</span>
        </button>
        <button className="ilp-nav-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Help</span>
        </button>
        <button className="ilp-nav-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span>Profile</span>
        </button>
      </div>

      {/* Invite Modal */}
      {showInvite && (
        <div className="ilp-modal-overlay ilp-invite-overlay" onClick={() => setShowInvite(false)}>
          <div className="ilp-invite-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ilp-invite-modal-header">
              <div>
                <h3>Invite a Tourist</h3>
                <p>Scan this QR code to open the ILP application.</p>
              </div>
              <button className="ilp-close-btn" onClick={() => setShowInvite(false)} aria-label="Close invite">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="ilp-invite-qr">
              <div className="ilp-invite-qr-box">
                <QRCodeSVG value={inviteUrl} size={180} />
              </div>
            </div>

            <div className="ilp-invite-link">
              <label>Share Link</label>
              <div className="ilp-invite-link-row">
                <input value={inviteUrl} readOnly />
                <button className="ilp-invite-copy" onClick={handleCopy}>
                  {copied ? 'Copied' : 'Copy'}
                </button>
                <button className="ilp-invite-whatsapp" onClick={handleWhatsAppShare} type="button">
                  <svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
                    <path d="M19.11 17.64c-.28-.14-1.64-.81-1.9-.9-.25-.09-.44-.14-.63.14-.19.28-.72.9-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.73-1.38-1.64-1.54-1.92-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.19-.28.28-.46.09-.19.05-.35-.02-.5-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.48-.63-.49-.16-.01-.35-.01-.53-.01-.19 0-.5.07-.76.35-.26.28-.99.97-.99 2.36 0 1.39 1.02 2.73 1.16 2.92.14.19 2.01 3.07 4.87 4.31.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.11.55-.08 1.64-.67 1.87-1.31.23-.64.23-1.18.16-1.31-.07-.12-.25-.19-.53-.33z" />
                    <path d="M16 3C9.38 3 4 8.17 4 14.53c0 2.11.6 4.07 1.63 5.75L4 29l9.08-1.58c1.72.91 3.7 1.43 5.92 1.43 6.62 0 12-5.17 12-11.53S22.62 3 16 3zm0 23.35c-2.06 0-3.97-.57-5.59-1.55l-.4-.24-5.39.94.97-5.02-.26-.41a9.86 9.86 0 0 1-1.55-5.3C3.78 9.57 9 4.9 16 4.9s12.22 4.67 12.22 9.63S23 26.35 16 26.35z" />
                  </svg>
                  <span>WhatsApp</span>
                </button>
              </div>
             
            </div>

           
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeScreen;

